module.exports = __webpack_public_path__ + "img/5.415c20b4.png";